export default __webpack_public_path__ + "static/media/info.757d988a.svg";